import { makeEnum } from '@transcend-io/type-utils';

export const DiscoClassScanType = makeEnum({
  SchemaOnly: 'SCHEMA_ONLY',
  FullScan: 'FULL_SCAN',
});

/** Overload type */
export type DiscoClassScanType =
  (typeof DiscoClassScanType)[keyof typeof DiscoClassScanType];

export const DiscoClassScanStatus = makeEnum({
  InProgress: 'IN_PROGRESS',
  Paused: 'PAUSED',
  Complete: 'COMPLETE',
  Disconnected: 'DISCONNECTED',
  Error: 'ERROR',
});

/** Overload type */
export type DiscoClassScanStatus =
  (typeof DiscoClassScanStatus)[keyof typeof DiscoClassScanStatus];
